import { createFeatureSelector, createSelector } from '@ngrx/store';
import { routerStateConfig } from './router-store.module';
import { MergeRouteReducerState } from './router-state';

export const getRouterReducerState = createFeatureSelector<MergeRouteReducerState>(routerStateConfig.stateKey);

export const getMenuRoute = createSelector(getRouterReducerState, (routerReducerState): string | null => {
    if (routerReducerState != null
      && routerReducerState.state != null
      && routerReducerState.state.params != null) {
        return routerReducerState.state.params.menuId
      } else {
        return null;
      }
  });

export const getQueryParams = createSelector(getRouterReducerState, (routerState: MergeRouteReducerState): any => {
  if (routerState != null && routerState.state != null) {
    return routerState.state.queryParams;
  }
  return null;
})